import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { useCallback, useState } from 'react';

export const AG_TABLE_SELECTION_COLUMN_ID = '__selection__';

const defaultSelectionColumn: ColDef = {
  colId: AG_TABLE_SELECTION_COLUMN_ID,
  checkboxSelection: true,
  headerCheckboxSelection: true,
  suppressMenu: true,
  lockPosition: true,
  pinned: 'left',
  width: 52,
  minWidth: 52,
  maxWidth: 52,
  sortable: false,
  resizable: false,
  suppressMovable: true,
};

export const createRowSelectionColumn = (overrides: ColDef = {}): ColDef => ({
  ...defaultSelectionColumn,
  ...overrides,
});

export const prependRowSelectionColumn = (columnDefs: ColDef[], enabled: boolean, overrides: ColDef = {}): ColDef[] => {
  if (!enabled) {
    return columnDefs;
  }

  return [createRowSelectionColumn(overrides), ...columnDefs];
};

export const useAgTableRowSelection = <TRow>() => {
  const [selectedRows, setSelectedRows] = useState<TRow[]>([]);

  const handleSelectionChanged = useCallback((event: SelectionChangedEvent) => {
    setSelectedRows((event.api.getSelectedRows() as TRow[]) || []);
  }, []);

  const clearSelection = useCallback((gridApi?: GridApi | null) => {
    setSelectedRows([]);
    gridApi?.deselectAll();
  }, []);

  return {
    selectedRows,
    setSelectedRows,
    handleSelectionChanged,
    clearSelection,
  };
};
